import React from 'react';
import { ArrowRightIcon, ShieldCheckIcon } from 'lucide-react';
interface CTAButtonProps {
  className?: string;
}
export function CTAButton({
  className = ''
}: CTAButtonProps) {
  return <div className={`flex flex-col items-center w-full my-8 ${className}`} data-id="element-1">
      <a href="https://snorestop.glowliftessencemx.com/" className="group relative w-full max-w-md flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white text-lg md:text-xl font-bold py-4 px-8 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5" data-id="element-2">
        See the Official Offer Page
        <ArrowRightIcon className="w-5 h-5 md:w-6 md:h-6 group-hover:translate-x-1 transition-transform" data-id="element-3" />
      </a>

      <div className="flex items-center gap-2 mt-3 text-sm text-gray-500 font-medium" data-id="element-4">
        <ShieldCheckIcon className="w-4 h-4 text-green-600" data-id="element-5" />
        <span data-id="element-6">90-Day Money-Back Guarantee + Secure Checkout</span>
      </div>
    </div>;
}